import Cookies, { CookieSetOptions } from 'universal-cookie'

const cookies = new Cookies(null, { domain: 'myfreecams.com', path: '/' })

export const getCookie = (name: string) => {
    return cookies.get<string | undefined>(name, { doNotParse: true })
}

export const setCookie = (
    name: string,
    value: string,
    cookieAttributes?: CookieSetOptions,
) => {
    cookies.set(name, value, cookieAttributes)
}

export const eraseCookie = (name: string) => {
    cookies.remove(name)
}
